export default __webpack_public_path__ + "static/media/manrope-light.668f3b44.woff";